/** Official Top Achievers photography / media release language (parent per-child consent). */
export const PHOTOGRAPHY_CONSENT_TEXT =
  "I authorize Top Achievers to photograph and/or record video or audio of my child during program activities, and to use these images/recordings, with or without my child's name, for educational, promotional, marketing, and fundraising purposes, including on our website, social media, and printed materials. I understand this consent is voluntary, that declining will not affect my child's participation, that no compensation will be provided, and that I may revoke this consent at any time by contacting info@topachieversplano.org. This consent remains in effect indefinitely unless revoked.";

export const PHOTOGRAPHY_CONSENT_TITLE = "Photography, video, and audio release (required per child)";

/**
 * @param {boolean | null | undefined} value - `true` = consented, `false` = declined, `null`/`undefined` = unset
 * @returns {string} Empty when valid; otherwise a user-facing validation message.
 */
export function validateRequiredPhotographyConsent(value) {
  if (value === true || value === false) return "";
  return "Photography, video, and audio release is required. Select Yes, I consent or No, I do not consent.";
}

/** Normalize stored/API photography consent to `true`, `false`, or `null` (unset). */
export function normalizePhotographyConsent(raw) {
  if (raw === true) return true;
  if (raw === false) return false;
  return null;
}

/** True when check-in staff should warn (no explicit consent on the child profile). */
export function shouldWarnPhotographyConsentAtCheckIn(consent) {
  return consent !== true;
}

/** Display label for participant roster / check-in tables. */
export function getPhotographyConsentLabel(consent) {
  if (consent === true) return "Consented";
  if (consent === false) return "No consent";
  return "Not set";
}

/** Sort key: Consented first, then Not set, then No consent (staff see declines last). */
export function getPhotographyConsentSortKey(consent) {
  if (consent === true) return "1_consented";
  if (consent === false) return "3_no_consent";
  return "2_not_set";
}

/** Staff-facing alert when media release is missing or declined on the child profile. */
export const PHOTOGRAPHY_CONSENT_CHECKIN_ALERT =
  "No photography / media consent on file. Provide a separate badge and do not include this student in photos or recordings.";
